<template>
  <div class="main mainQMultiple mainT2">
      <div class="testT-section testT2 testOver">
          <ul id="test6-ul">
              <li :class="[position === 1 ? 'vueActive' : 'vueLiNone']">
                    <h4>Vous avez l’habitude de pratiquer cette ou ces activités (sport, loisir) :</h4>
                    <ul class="modeleBase">
                        <li class="optionPerso general">
                          <button :class="[{selected: select[1].click === 4}]" @click="selectOption(1, 4)">
                            <p>Quotidiennement</p>
                          </button>
                        </li>
                        <li class="optionPerso general">
                          <button :class="[{selected: select[1].click === 3}]" @click="selectOption(1, 3)">
                            <p>3 à 6 fois par semaine</p>
                          </button>
                        </li>
                        <li class="optionPerso general">
                          <button :class="[{selected: select[1].click === 2}]" @click="selectOption(1, 2)">
                            <p>1 à 2 fois par semaine</p>
                          </button>
                        </li>
                        <li class="optionPerso general">
                          <button :class="[{selected: select[1].click === 1}]" @click="selectOption(1, 1)">
                            <p>de façon irrégulière</p>
                          </button>
                        </li>
                        <li class="optionPerso general">
                          <button :class="[{selected: select[1].click === 0}]" @click="selectOption(1, 0)">
                            <p>jamais</p>
                          </button>
                        </li>
                    </ul>
                </li>

                <li :class="[position === 2 ? 'vueActive' : 'vueLiNone']">
                    <h4>La durée moyenne de vos séances d’activité physique (sport, loisir) :</h4>
                    <ul class="modeleBase">
                        <li class="optionPerso moyenne">
                          <button :class="[{selected: select[2].click === 4}]" @click="selectOption(2, 4)">
                            <p>60 minutes et plus</p>
                          </button>
                        </li>
                        <li class="optionPerso moyenne">
                          <button :class="[{selected: select[2].click === 3}]" @click="selectOption(2, 3)">
                            <p>30 à 60 minutes</p>
                          </button>
                        </li>
                        <li class="optionPerso moyenne">
                          <button :class="[{selected: select[2].click === 2}]" @click="selectOption(2, 2)">
                            <p>15 à 30 minutes</p>
                          </button>
                        </li>
                        <li class="optionPerso moyenne">
                          <button :class="[{selected: select[2].click === 1}]" @click="selectOption(2, 1)">
                            <p>moins de 15 minutes</p>
                          </button>
                        </li>
                        <li class="optionPerso moyenne">
                          <button :class="[{selected: select[2].click === 0}]" @click="selectOption(2, 0)">
                            <p>aucune activité</p>
                          </button>
                        </li>
                    </ul>
                </li>
                    
                <li :class="[position === 3 ? 'vueActive' : 'vueLiNone']">
                    <h4>Combien de mois par an exercez-vous cette ou ces activités (sport, loisir) ?</h4>
                    <ul class="modeleBase">
                        <li class="optionPerso activite_tmp">
                          <button :class="[{selected: select[3].click === 2}]" @click="selectOption(3, 3)">
                            <p>plus de 9 mois</p>
                          </button>
                        </li>
                        <li class="optionPerso activite_tmp">
                          <button :class="[{selected: select[3].click === 2}]" @click="selectOption(3, 2)">
                            <p>entre 4 et 9 mois</p>
                          </button>
                        </li>
                        <li class="optionPerso activite_tmp">
                          <button :class="[{selected: select[3].click === 1}]" @click="selectOption(3, 1)">
                            <p>moins de 4 mois</p>
                          </button>
                        </li>
                        <li class="optionPerso activite_tmp">
                          <button :class="[{selected: select[3].click === 0}]" @click="selectOption(3, 0)">
                            <p>jamais</p>
                          </button>
                        </li>
                    </ul>
                </li>

                <li :class="[position === 4 ? 'vueActive' : 'vueLiNone']">
                    <h4>L’activité physique (sport, loisir) entraîne-t-elle habituellement chez vous :</h4>
                    <ul class="modeleBase">
                        <li class="optionPerso activite_sportive">
                          <button :class="[{selected: select[4].click === 3}]" @click="selectOption(4, 3)">
                            <p>une fatigue importante et/ou un essoufflement important</p>
                          </button>
                        </li>
                        <li class="optionPerso activite_sportive">
                          <button :class="[{selected: select[4].click === 2}]" @click="selectOption(4, 2)">
                            <p>une fatigue et un essoufflement modérés</p>
                          </button>
                        </li>
                        <li class="optionPerso activite_sportive">
                          <button :class="[{selected: select[4].click === 1}]" @click="selectOption(4, 1)">
                            <p>pas de sensation de fatigue ni d’essoufflement</p>
                          </button>
                        </li>
                    </ul>
                </li>

                <li :class="[position === 5 ? 'vueActive' : 'vueLiNone']">
                    <h4>Vous restez au repos (sommeil, sieste ou repos éveillé)</h4>
                    <ul class="modeleBase">
                        <li class="optionPerso repos">
                          <button :class="[{selected: select[5].click === 3}]" @click="selectOption(5, 3)">
                            <p>moins de 12 heures par jour</p>
                          </button>
                        </li>
                        <li class="optionPerso repos">
                          <button :class="[{selected: select[5].click === 2}]" @click="selectOption(5, 2)">
                            <p>entre 12 et 16 heures par jour</p>
                          </button>
                        </li>
                        <li class="optionPerso repos">
                          <button :class="[{selected: select[5].click === 1}]" @click="selectOption(5, 1)">
                            <p>entre 16 et 20 heures par jour</p>
                          </button>
                        </li>
                        <li class="optionPerso repos">
                          <button :class="[{selected: select[5].click === 0}]" @click="selectOption(5, 0)">
                            <p>plus de 20 heures</p>
                          </button>
                        </li>
                    </ul>
                </li>
          </ul>
          
          
      </div>
  </div>
</template>

<script>
export default {
  name: "Test_6",
  data() {
    return {
      select: { 1 : {click : false, option : 4, id :"habitude", value:"Quotidiennement"}, 
                2 : {click : false, option : 4, id:"moyenne", value:"60 minutes et plus"}, 
                3 : {click : false, option : 3, id:"activite_tmp", value:"plus de 9 mois"}, 
                4 : {click : false, option : 3, id :"activite_sportive", value :"une fatigue importante et/ou un essoufflement important"},
                5 : {click : false, option : 3, id :"repos", value :"moins de 12 heures par jour"}
                },
      position: 1,
      resultat6:0,
    };
  },
  methods: {
    selectClick(selected){
      if (this.select[selected].click == false){
        this.select[selected].click = true;
      }else {
        this.select[selected].click = false;
      }
    },
    valueOption(liste, id){
      var options = document.getElementsByClassName(id);
      var contenu = [];
      var option = this.select[liste].option;
      Object.keys(options).forEach(function (element, index) {
         contenu.unshift(options[element].textContent);
      });
      //console.log (contenu[option], option);
      if (liste == 4){
          this.select[liste].value = contenu[option -1];
      }else{
      this.select[liste].value = contenu[option];
      }
      this.resultat6 += option;
      return contenu[option];
    },
    selectOption(liste, optionC){
      this.select[liste].option = optionC;
      this.valueOption(liste, this.select[liste].id);
      this.select[liste].click = false;
      this.position++;
      if (liste == 5){
        console.log(this.resultat6);
        localStorage.vive = this.resultat6;
        this.$emit('choice6');
      }
    }
  },
};
</script>
<style>
.modeleBase{
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  list-style: none;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}
#test6-ul {
  height: 85%;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  list-style: none;
  width: 90%;
  padding: 0;
  margin: 0;
  margin-left: auto;
  margin-right: auto;
  padding-top: 0px;
  position: relative;
  min-height: none;
}

#test6-ul li {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  height: 100%;
  width: 100%;
  margin-bottom: 0px;
  position: inherit;
  z-index: 0;
}
.vueActive, .vueLiNone {
  height: 100%;
}
.modeleBase li button {
  border: none;
  border-radius: 15px;
  background-color: #473334;
  color: white;
  width: 100%;
  }
.selected {
  background-color: #54c7da !important;
  cursor: pointer;
}
.modeleBase li button:hover{
  background-color: #54c7da !important;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/Test/Test_6.vue